import { render, staticRenderFns } from "./info-cell.vue?vue&type=template&id=7c7b87b0&scoped=true&"
import script from "./info-cell.vue?vue&type=script&lang=ts&"
export * from "./info-cell.vue?vue&type=script&lang=ts&"
import style0 from "./info-cell.vue?vue&type=style&index=0&id=7c7b87b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b87b0",
  null
  
)

export default component.exports